import React from "react";
import "../InputStyles.css";

const Textarea = ({ label, name, value, onChange, placeholder = " " }) => {
    const textareaId = name || "textarea_" + Math.random().toString(36).substr(2, 9);

    return (
        <div className="input_group">
            <textarea
                id={textareaId}
                name={name}
                className="input_field"
                placeholder={placeholder}
                value={value}
                onChange={onChange}
                required
                rows={4}
                style={{ resize: "none" }}
            />
            <label className="input_label" htmlFor={textareaId}>{label}</label>
        </div>
    );
};

export default Textarea;
